// axiosInstance.js
import axios from 'axios';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import { LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK } from '../assets/constants/BrowserStorageKeys';
import { API_TIMEOUT, TOAST_ERROR } from '../assets/constants/Constants';
import ShowToast from '../components/ToastComponent';
import { decryptObjectDeep } from '../lib/Utils';



const createAxiosInstance = () => {
  return  axios.create({
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: API_TIMEOUT,
  });
  
}

const axiosInstance = createAxiosInstance()


// Request Interceptor
axiosInstance.interceptors.request.use((config) => {
  // If baseURL already provided (master API), don't override it
	if (!config.baseURL) {
		const stored = getSecureItemFromSpecificStorage(
			LOCAL_STORAGE,
			LS_DOMAIN_AND_LOCKER_BANK
		);
		const domain = stored?.domain;
		config.baseURL =
			domain?.startsWith("http")
				? `${domain}api/`
				: `https://${domain}/api/`;
	}
	return config;
});
  
  axiosInstance.interceptors.response.use(
    (response) => {
      // Any status code that lies within the range of 2xx causes this function to trigger
      return decryptObjectDeep(response);
    },
    (error) => {
      console.log('Axios Error:', error);
      if (error.code === 'ECONNABORTED') {
        ShowToast("Timeout Error",TOAST_ERROR);
        console.error('Error: Timeout exceeded');
      } else if (!error.response) {
        console.error('Error: Network Error');
        ShowToast("Network Error",TOAST_ERROR);
      } else {
        const { status, data, headers} = error?.response;
        switch (status) {
          case 400:
            console.error('Error 400: Bad Request', data);
            if(data?.message){
              if(data?.message !== 'No Data Found'){
                ShowToast(data?.message,TOAST_ERROR)
              }
            }
            break;
          case 401:
            console.error('Error 401: Unauthorized', data);
            break;
          case 403:
            if(data?.message){
                ShowToast(data?.message,TOAST_ERROR)
            }
            console.error('Error 403: Forbidden', data);
            break;
          case 404:
            console.error('Error 404: Not Found', data);
            break;
          case 406:
            //const errorKeys = Object.keys(data?.error);
            // if (errorKeys.length > 0) {
            //   console.log("firstErrorMessageArray[0]".firstErrorMessageArray[0])
            //   const firstErrorMessageArray = data?.error[errorKeys[0]];
            //   if (Array.isArray(firstErrorMessageArray) && firstErrorMessageArray.length > 0) {
            //     ShowToast(firstErrorMessageArray[0],TOAST_ERROR);
            //   }
            // }
              const errorArray = data?.error;
              if (Array.isArray(errorArray) && errorArray.length > 0) {
                const firstError = errorArray[0];
                if (Array.isArray(firstError?.message) && firstError.message.length > 0) {
                  ShowToast(firstError.message[0], TOAST_ERROR);
                }
              }
            console.error('Error 406: Not Acceptable', data,error);
            break;
          case 502:
            console.error('Error 502: Bad Gateway', data);
            if(data?.message){
                ShowToast(data?.message,TOAST_ERROR)
            }
            break;
          case 500:
            console.error('Error 500: Internal Server Error', data);
            break;
          default:
            console.error(`Error ${status}:`, data);
        }
        console.error('Error Headers:', headers);
      }
      return Promise.reject(error);
    }
  );

export default axiosInstance;